import HttpService from "../../../services/HttpService";
import { Branch } from "../models/Branch";

export interface IBranchOptions {
    latLng: { lat: number, lng: number };
    radius: number;
    limit?: number;
    page: number;
    type?: number;
}

export async function getBranches({ latLng, radius, limit = 7, page = 1, type = 1 }: IBranchOptions): Promise<Branch[]> {
    const timestamp = Math.floor(Date.now() / 10000);
    try {
        const results = await HttpService.get<Branch[]>(`${process.env.GATSBY_API_URL}/branches/search?`,
            null,
            {
                params: {
                    timestamp: timestamp,
                    latitude: latLng.lat,
                    longitude: latLng.lng,
                    radius,
                    page,
                    limit,
                    type
                }
            });

        return results;
    } catch (e) {
        console.error("there is an error retrieving branches");
        return null;
    }
}